import React, { useEffect } from "react";
import { useNavContext } from "../../context-api/nav-context";
import PageHeaderSmall from "../../components/PageHeaderSmall";

const Conditions = () => {
  const { closeNavbarMenu } = useNavContext();
  const title = "Terms & Conditions";
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <PageHeaderSmall title={title} />
      <section
        className="section-wrapper conditions_global"
        onMouseOver={closeNavbarMenu}
      >
        <div className="conditions_body">
          <h2 className="conditions_subtitle">The Company</h2>
          <p className="conditions_paragraph">
            In these Terms & Conditions AquaHeat Plumbing & Heating LTD (a
            company registered in England & Wales with company number 08383496)
            will be referred to as ‘the Company' and the person ordering the
            product will be referred to as ‘the customer'.
          </p>
          <h2 className="conditions_subtitle">Site Survey & Inspection</h2>
          <p className="conditions_paragraph">
            After an order is placed with the Company, there is an opportunity
            for the customer to send photos to the Company using a customer
            specific weblink. This link is displayed on screen immediately after
            the order is placed and also sent on email. By viewing the photos in
            advance the Company can discuss any technical aspects of the
            installation prior to the engineer attending; this makes the
            installation process run as smoothly as possible ensuring the right
            boiler and materials are delivered to enable a suitable
            installation.
          </p>
          <p className="conditions_paragraph">
            The customer agrees that any photos supplied during or after the
            ordering process are true and accurate images of what the engineer
            will see at the installation site.
          </p>
          <p className="conditions_paragraph">
            If, upon physical inspection of the site, it is determined that
            equipment ordered is unsuitable or technically not possible to
            install as ordered, then the Company will inform the customer of why
            the installation cannot go ahead as ordered and discuss alternative
            options including any delay to installation that may be incurred. If
            the customer declines the alternatives offered, or if no
            alternatives can be offered, then the Company will give a full
            refund to the customer and remove any materials that may have
            already been delivered to site.
          </p>
          <p className="conditions_paragraph">
            In exceptional cases where the Company determines an installation
            cannot take place, the Company reserves the right to decline any
            order at any time. Should the Company decline an order, no damages
            or expenses of any kind shall be payable by the Company to the
            customer beyond the refund of any money already paid in relation to
            the contract.
          </p>
          <p className="conditions_paragraph">
            If, upon physical inspection of the site, it is determined that more
            equipment or a significant amount of extra work is required, then
            the Company will inform the customer of any increase in costs prior
            to these costs being incurred. The customer will also be informed of
            any delay to installation that may be incurred. If the customer
            declines any extra equipment or work required to facilitate the
            installation work they are entitled to a full refund.
          </p>
          <p className="conditions_paragraph">
            The Company reserves the right to decline any order at any time up
            until completion. Should the Company decline an order, no damages or
            expenses of any kind whatsoever shall be payable by the Company to
            the customer beyond the refund of any money already paid in relation
            to the contract.
          </p>
          <p className="conditions_paragraph">
            Any changes in materials and/or specifications from those detailed
            in the contract, will only apply when supported by an Amendment to
            Order document issued by the Company, which must be approved by the
            customer (this approval may be carried out either by physical
            documentation or by email).
          </p>
          <p className="conditions_paragraph">
            Whilst every effort is made to ensure the delivery and installation
            timescales agreed during the ordering process are met, the Company
            reserves the right to delay installation for reasons including (for
            example) fires, strikes, illness, severe weather, lockouts,
            terrorism, war and any other causes beyond the control of the
            Company interfering with its execution or completion of the
            contract. Time shall not be deemed to be the essence of the
            Contract.
          </p>
          <p className="conditions_paragraph">
            [Abnormal boiler flues]. If the flue length required to install a
            boiler is longer than 3m, the Company reserve the option to pass on
            to the customer costs associated with extra flue parts required.
            This will be clearly discussed prior to any installation commencing.
            None of the boilers supplied by the Company work with twin flue
            options, if the customer’s existing boiler has two flue pipes (ie
            one for air intake, the other for exhaust) then the customer should
            call the Company before placing their order to discuss suitable
            options. If the customer’s boiler is in the middle of the house and
            the flue goes out of the wall, please call the company before
            placing your order as this is an abnormal flue.
          </p>
          <h2 className="conditions_subtitle">Carrying Out Work</h2>
          <p className="conditions_paragraph">
            The customer will need to provide free access to and from the
            installation property (both internal and external access will likely
            be required) on the agreed dates so that we can deliver and install
            equipment. You must also provide free access to water, gas and
            electricity (where applicable) for installing and testing your new
            equipment.
          </p>
          <p className="conditions_paragraph">
            Our Engineers come to work to deliver services in your home. They
            aim to treat you courteously at all times and expect you to treat
            them in a similarly respectful way. We take seriously any
            threatening, abusive or violent behaviour against any of our
            Engineers. Where an incident of threatening, abusive or violent
            behaviour towards our Engineers occurs, the Engineer will
            immediately leave your home and the property made safe and the
            incident may be reported to the police. BOXT will not send another
            Engineer to your home until an investigation and risk assessment has
            been carried out. BOXT reserve the right to terminate the contract
            should the work environment be deemed unsafe for our Engineers.
          </p>
          <p className="conditions_paragraph">
            It is the responsibility of the customer to ensure there is adequate
            vehicle parking for the engineer to park their van within 25 meters
            of the entrance to the property. Any charges for parking are to be
            paid by the customer. If a permit for parking is required, it is the
            responsibility of the customer to organise the permit or notify the
            Company of the restriction at least two working days before the
            engineer/delivery is due to arrive (or at the time of ordering,
            whichever is sooner).
          </p>
          <p className="conditions_paragraph">
            During the fulfilment of this contract, the customer agrees to
            provide a safe and respectful workplace for any persons attending
            the installation address. Persons attending a property to carry out
            work connected with this contract will leave the property if rude,
            abusive or unsafe conditions are encountered. If this happens, it
            will be at the sole discretion of the Company if a reattendance is
            arranged and what the charge for such a reattendance will be. In any
            event, no refund will be due from the Company to the customer if the
            site is vacated for reasons of safety, abuse or general rudeness.
          </p>
          <p className="conditions_paragraph">
            Prior to any attendance by the Company, it is the customer's
            responsibility to secure any permissions, licences or permits that
            may be required to authorise the work. Examples of such permit could
            be a listed building consent, landlord consent or freeholder
            agreement.
          </p>
          <p className="conditions_paragraph">
            Existing pipework, valves, radiators and other equipment should all
            be in working order. If they have been poorly installed or have
            become faulty any such failure or consequential damage is in no way
            the responsibility of the company (irrespective of if an engineer
            working on behalf of the Company has touched them or not).
          </p>
          <p className="conditions_paragraph">
            When completing the installation of new or upgraded pipework, the
            route for these pipes should be discussed with the customer and will
            need to be installed in a way which makes the most functional sense
            from an engineering point of view, not simply aesthetic. Pipework
            may need to be surface mounted and clipped in place. Our engineers
            will not bury pipework in the walls, under the ground or box the
            pipework in.
          </p>
          <p className="conditions_paragraph">
            The Company will always try to complete work before 6pm on the day
            of installation but may on occasion need to use a reasonable amount
            of overtime to achieve completion. It is a condition of this
            contract that your approval to such overtime is granted, although we
            will endeavour to minimise any disruption or inconvenience.
          </p>
          <p className="conditions_paragraph">
            Due to the Company's policy of continuous improvement, the customer
            shall have the benefit of any modification the Company may make to
            its products and procedures, albeit these changes may be made
            without prior notice to the customer. All illustrations within the
            company's website (and any advertising, marketing material or
            literature) and that of its suppliers are subsequently intended as a
            guide only.
          </p>
          <p className="conditions_paragraph">
            The customer understands that during/after any plumbing work carried
            out by the Company there could be changes in the water pressure in
            existing plumbing. Whilst the Company will exercise reasonable care
            in visually assessing the suitability of existing systems/pipework
            for any likely changes in pressure, the Company will not be liable
            for any damage caused to existing plumbing installations or any
            consequential damage caused by the failure or incompatibility of
            existing pipework, taps, valves, showers, other fittings or any
            appliances.
          </p>
          <p className="conditions_paragraph">
            [Boilers & Showers] You should be aware that due to the wide variety
            of showers available in the market place it is not possible for the
            Company to determine if a shower and your boiler will be compatible.
            The Company will not be liable if your existing shower/boiler is not
            compatible for any reason with a new shower/boiler.
          </p>
          <p className="conditions_paragraph">
            Whilst engineers working on behalf of the Company will take
            reasonable care not to damage wiring, plumbing and other services at
            your property, the Company cannot be held responsible for any
            consequential damage caused to existing services/installations that
            are not clearly visible.
          </p>
          <p className="conditions_paragraph">
            The Company will not be liable for any damage to your home which is
            caused as a direct result of structural defects or weaknesses at the
            installation address whether they are visible or not. If you are
            unsure of the structural integrity of your building you should
            engage an appropriately qualified structural surveyor prior to any
            attendance the Company may arrange in connection with the contract.
          </p>
          <p className="conditions_paragraph">
            Products and building materials can vary in colour, texture and
            general appearance. The Company accepts no liability for any
            materials used during the installation process having variations in
            colour, texture and general appearance. When matching materials
            (such as bricks and tiles) to existing materials which are part of
            the house, a close match is often not possible due to older products
            becoming obsolete and the effects of weathering over time. In
            summary, the Company accepts no liability for any materials
            introduced to the property matching any existing materials and
            explicitly states variations in colour, texture and general
            appearance are likely and will be accepted by the customer. The
            customer agrees to make available their own materials, at their
            expense, at the time of the work taking place if they would like a
            specific material (such as a matching brick) to be used.
          </p>
          <p className="conditions_paragraph">
            When adding new equipment to your house, our engineer will need to
            inspect existing relevant infrastructure to ensure it meets current
            regulatory standards and is of suitable performance. Should your
            existing infrastructure fail to meet relevant standards/capacity
            then we will give you the options to bring the infrastructure up to
            a standard which allows new equipment to be connected. At this point
            you may cancel your order for a full refund. If you do not wish to
            authorise the required additional work(s) but still wish the new
            equipment to be installed, we will leave the equipment for final
            connection by others and will not be able to commission the
            equipment. In such circumstances the customer is still liable to
            make payment in full as if the installation had been completed.
          </p>
          <p className="conditions_paragraph">
            [Boilers being fitted in loft space] Where a boiler is to be fitted
            in a loft space, access to the loft must be via a fixed loft ladder.
            From the top of the fixed ladder the loft must have a suitably
            boarded walk way to the boiler location. At the boiler location, at
            least 1 m² of suitable boarding must be in place under the boiler.
            Permanent lighting should also be present. If the boiler is within 2
            meters of the loft hatch, the hatch will need to be able to be
            sealed off whilst an engineer works in the loft.
          </p>
          <p className="conditions_paragraph">
            The engineer will take pictures of your installed equipment and
            relevant infrastructure for the Company's auditing process and for
            our own records. The engineer may also attend with other people
            including managers, supervisors, trainees or apprentices. From time
            to time the Company may use pictures of installed equipment for
            marketing purposes.
          </p>
          <p className="conditions_paragraph">
            During installation, our health and safety plan requires the
            engineer to have access to working communication devices. If for any
            reason the engineer is unable to get mobile phone reception, the
            house holder agrees to make available to the engineer access to
            their telephone and internet connection for no charge.
          </p>
          <p className="conditions_paragraph">
            Upon completion of all physical works at the property, the customer
            (or their representative) may inspect the work before the engineer
            departs. Once the Company's appointed engineer is satisfied that the
            work is complete and the customer (or their representative) has been
            given the opportunity to inspect, then all works required to fulfil
            the contract are deemed to have been completed.
          </p>
          <p className="conditions_paragraph">
            When installing new equipment other trades may be required to
            complete the work. For example, an electrician may be required to
            wire controls to a new boiler. In such circumstances, the company
            will endeavour to leave the equipment working until another engineer
            can attend and perfect the installation at a time convenient with
            the customer.
          </p>
          <p className="conditions_paragraph">
            Sometimes things do not go to plan with the installation of new
            equipment. The customer agrees to give the Company and its engineers
            reasonable opportunities to put things right by providing access to
            the installation address and time to remedy any faults or problems.
            In addition to this, the customer undertakes to minimise or avoid
            any losses it may suffer as a result of the actions (or non-actions)
            of the Company or the appointed engineer.
          </p>
          <p className="conditions_paragraph">
            New equipment can sometimes not function correctly once first
            installed (for example a part may have become dislodged internally
            during transit). The Company works proactively with both customers
            and product manufacturers/suppliers in such circumstances to rectify
            the issue as quickly as possible. Sometimes faulty equipment needs
            refitting which can cause significant delays and inconvenience; the
            Company will do all that it reasonably can to minimise disruption to
            the household.
          </p>
          <p className="conditions_paragraph">
            If something within the customer's responsibilities/control (such as
            removal of asbestos or improving existing infrastructure) prevents
            delivery and/or installation of any goods/services ordered for more
            than 12 months after the order was placed with the Company, then the
            Company will be deemed to have performed the contract in full and
            entitled to retain all monies paid to date without deduction or
            refund in full or in part without the supply of any further
            goods/services.
          </p>
          <p className="conditions_paragraph">
            The Company are not liable for any loss of profit, loss of business,
            business interruption or business opportunity under any
            circumstances.
          </p>
          <p className="conditions_paragraph">
            The Company are not liable for any loss of profit, loss of business,
            business interruption or business opportunity under any
            circumstances.
          </p>
          <h2 className="conditions_subtitle">Site Survey & Inspection</h2>
          <p className="conditions_paragraph">
            If paying by credit or debit card, the payment of cleared funds from
            the customer to the Company is required prior to delivery and/or
            installation of goods. Payment is only deemed to have been received
            once the funds are showing in the Company's bank account as cleared
            funds. If the customer instigates an attempt to clawback payments
            (for example requesting a credit card chargeback) then the Company
            can pass on any costs and/or losses associated with dealing with and
            defending such action.
          </p>
          <p className="conditions_paragraph">
            All final invoices issued by the Company to the customer are issued
            after payment has been made and goods have been installed. Whilst
            any money is outstanding, the Company is entitled to delay or defer
            any or all work without any penalty due from the Company to the
            customer whatsoever.
          </p>
          <p className="conditions_paragraph">
            If you have entered a credit agreement with a finance provider the
            Company has introduced you to, you will need to enter a separate
            agreement with that provider (payment of the contract balance will
            be automatically processed between the Company and the Finance
            Provider when the balance becomes due).
          </p>
          <p className="conditions_paragraph">
            If the Customer has entered a credit agreement via one of the
            Company's nominated finance providers, the terms of the agreement
            will apply as part of this contract. If the credit agreement is
            later cancelled, then subject to the terms of the 1974 Consumer
            Credit Act, the contract balance will become immediately payable by
            the customer. This does not affect your statutory rights.
          </p>
          <p className="conditions_paragraph">
            All goods supplied remain the property of the Company even though
            installed, by way of a lien, until fully paid for and the Company
            reserves the right of re-entry to remove any such goods whether
            fixed or otherwise, which remain unpaid for.
          </p>
          <p className="conditions_paragraph">
            All the prices displayed by the Company include VAT unless otherwise
            stated. Delivery and other service charges will be confirmed on
            screen during the specification and purchase process. After the
            point a customer completes an order to the Company, the price should
            not change even if the applicable VAT rate does.
          </p>
          <p className="conditions_paragraph">
            In the event of suspension or cancellation of the work at the
            request of the customer, or lack of instructions or delay on site
            caused by matters beyond the control of the Company, any extra
            expenses thereby incurred or losses suffered by the Company shall be
            chargeable to the customer along with a reasonable addition for
            administration and overhead costs. This condition shall not be
            construed as to affect any statutory or common law rights of the
            customer.
          </p>
          <p className="conditions_paragraph">
            The Company reserves the right at its sole discretion to accept or
            refuse any order placed by the customer until the appointed engineer
            has inspected the site and accepted the order.
          </p>
          <p className="conditions_paragraph">
            The customer is responsible for disposing of any packaging. Debris
            will be removed from site as part of the contract price, but this
            does not include the removal of any dangerous/hazardous waste
            material such as asbestos which we become aware of before or during
            the installation. It is the responsibility of the customer to
            arrange for the safe removal and disposal from site at their own
            expense and to provide the Company with a Clean Air Certificate as
            proof this work has been completed.
          </p>
          <p className="conditions_paragraph">
            If the customer would like to keep any old equipment or material
            that will be removed as part of any installation work ordered, they
            must let the appointed engineer know on the day of install. If
            requested by the customer, the Company will organise a skip for
            removal of all materials at cost price.
          </p>
          <p className="conditions_paragraph">
            [Converting to a combination boiler] Any water storage tanks in the
            loft which are decommissioned as part of the work will be left in
            place unless the engineer is requested to remove them whilst on
            site.
          </p>
          <p className="conditions_paragraph">
            Party Wall Act; it is the responsibility of the customer to
            undertake a party wall agreement with any neighbouring properties
            where required in advance of the Company attending site to carry out
            work.
          </p>
          <p className="conditions_paragraph">
            Under Construction (Design and Management) Regulations 2015 the
            Company needs to ensure operatives working on the site have access
            to welfare facilities including; a toilet, washing facilities,
            drinking water and facilities for rest in a warm indoor area. To
            reduce costs, the customer agrees to provide access to these
            facilities within the existing property for workers to use in a
            clean and respectful way. If the customer would like the Company to
            make alternative arrangements to comply with these CDM Regulations,
            they will notify the Company at least 14 days before any onsite
            works are due to commence and pay the additional cost of hiring such
            facilities 7 days prior to work commencing.
          </p>
          <p className="conditions_paragraph">
            Once the customer selects an installation date during the online
            order process, it's reserved for one hour. To confirm the
            installation date, the payment process (including the completion of
            any finance documents) needs to be finished by the customer within
            one hour. If the customer does not complete the payment process
            within an hour, the Company will endeavour to install/deliver
            equipment on the chosen date, however after the hour has lapsed, the
            company reserves the right to only offer an alternative
            delivery/installation slot.
          </p>
          <h2 className="conditions_subtitle">Cancellation</h2>
          <p className="conditions_paragraph">
            The customer will lose the right to cancel set out below should the
            Company complete the installation of your new equipment within 14
            days of your order being placed and the customers has requested that
            the Company perform services within this 14-day period as it will be
            deemed that the Company has been engaged to carry out urgent
            maintenance or repairs at the customer’s household.
          </p>
          <p className="conditions_paragraph">
            If the equipment has already been delivered, then the customer can
            cancel the order and receive a full refund. For the avoidance of
            doubt, due to the nature of the equipment, only the Company's
            appointed agents may transport equipment to be refunded. The
            customer is responsible for keeping any good to be refunded secure
            and provide access for collection when required.
          </p>
          <h2 className="conditions_subtitle">Warranty Specification</h2>
          <p className="conditions_paragraph">
            If the equipment has already been delivered, then the customer can
            cancel the order and receive a full refund. For the avoidance of
            doubt, due to the nature of the equipment, only the Company's
            appointed agents may transport equipment to be refunded. The
            customer is responsible for keeping any good to be refunded secure
            and provide access for collection when required.
          </p>
          <p className="conditions_paragraph">
            Auxiliary equipment supplied (for example radiators and thermostats)
            typically benefit from a 2 year parts and labour warranty. Other
            equipment and components (such as water softeners) have different
            warranties, these will vary depending upon the manufacturer. The
            Company will provide details of any such warranties upon request.
          </p>
          <p className="conditions_paragraph">
            Any workmanship will be done with reasonable skill and care by a
            suitably qualified person. The installation of pipework, joints and
            hand applied seals benefit from a 1 year warranty to include all
            parts and labour.
          </p>
          <p className="conditions_paragraph">
            Any guarantee shall be null and void if payments are not made on the
            due dates and the above conditions are not adhered to. Furthermore,
            neither the Company nor the manufacturer of any parts or equipment
            will be liable to you, whether under this contract or otherwise (and
            whether to carry out any warranty repairs or otherwise) where any
            failure, fault or problem arises as a result of; Any failure of the
            customer or third parties in the care, operation, inspection,
            servicing or maintenance of any of the equipment which is not done
            strictly in accordance with the manufactures instructions. The
            customer is responsible for maintaining full and accurate service
            records for all equipment, without such records any warranty will be
            void. Any deliberate damage or vandalism. Damage caused by
            circumstances outside the control of the Company or the equipment
            manufacturer. A variation in a flow rate of water to any installed
            equipment.
          </p>
          <p className="conditions_paragraph">
            The replacement of any lamps, bulbs or filaments are excluded from
            the warranty as are any timers, thermostats, lockout devices or
            other such devices that may be connected to, or part of, the
            equipment after the expiry of the individual items relevant warranty
            period as detailed by the manufacturer.
          </p>
          <p className="conditions_paragraph">
            The warranty set out above applies specifically to the equipment
            installed as part of this contract. Any existing timers, controls,
            radiators, towel rails, pipework, drains, other equipment or other
            devices are completely excluded from any warranty offered.
          </p>
          <p className="conditions_paragraph">
            The Company, or any engineer appointed by the Company, is under no
            obligation to carry out any visual inspection or testing on any
            existing equipment (except as part of their regulatory duties). The
            risk of any of the existing system failing once the new equipment is
            installed is solely the responsibility of the customer. If the
            customer wishes to reduce this risk they can, at their own expense
            and independently of the Company, organise a suitable inspection and
            test of the existing system prior to the installation of new
            equipment being carried out.
          </p>
          <p className="conditions_paragraph">
            When the Company re-attend at the customer’s request but no fault is
            found, or the issue relates to something the Company are not
            responsible for, then the Company reserve the right to make a
            reasonable charge to cover costs for such an attendance.
          </p>
          <p className="conditions_paragraph">
            [Converting to a combination boiler] If you are looking to convert
            from a standard boiler to a combi boiler there will likely be a
            pressure increase in your pipe work. This increase in pressure will
            exacerbate any existing/past leaks and can cause new leaks to
            appear. The Company are happy to reattend on two occasions for up to
            4 hours total free of further charge to identify and rectify leaks.
            After these attendances the Company will, upon request, provide a
            quote to renew all infrastructure that is likely to need further
            work/replacement.
          </p>
        </div>
      </section>
    </>
  );
};

export default Conditions;
